export default "__VITE_ASSET__BNagh9zd__"